import type { ConnectionCheckFailureDetails } from "./types";

// Azure Storage authors failures with an XML <Error><Code> body and x-ms-* headers;
// a proxy block page has neither, or isn't readable at all (opaque CORS TypeError).
export const isAzureAuthoredFailure = (details?: ConnectionCheckFailureDetails): boolean => {
  if (!details) {
    return false;
  }
  if (details.body && /<Error>[\s\S]*?<Code>/i.test(details.body)) {
    return true;
  }
  return Object.keys(details.headers ?? {}).some((header) => header.toLowerCase().startsWith("x-ms-"));
};
